import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { MotionConfig } from "motion/react";

import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { SessionProvider } from "@/lib/session";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: RootLayout,
});

function RootLayout() {
  return (
    <ThemeProvider>
      {/* "user": transforms fall away under prefers-reduced-motion, opacity
          stays, so the start page still cross-fades instead of sliding. */}
      <MotionConfig reducedMotion="user">
        <TooltipProvider delayDuration={250}>
          <SessionProvider>
            <Outlet />
            <Toaster />
          </SessionProvider>
        </TooltipProvider>
      </MotionConfig>
    </ThemeProvider>
  );
}
